export default __webpack_public_path__ + "static/media/vue-tour.48e817bd.jpg";